import { render, staticRenderFns } from "./BSReviewQuestionModal.vue?vue&type=template&id=6c0843c1"
import script from "./BSReviewQuestionModal.vue?vue&type=script&lang=js"
export * from "./BSReviewQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports